// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb0b1097","453":"a9cdd5ce","455":"44b21b72","977":"eea0cf8d"}[chunkId] + ".chunk.js";
};